import { Component } from '@angular/core';
import { RemoveOldCallsMcComponent } from '../remove-old-calls-mc/remove-old-calls-mc.component';
import { RemoveOldCallsRootsComponent } from '../remove-old-calls-roots/remove-old-calls-roots.component';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { RemoveOldConsultingCallsComponent } from '../remove-old-consulting-calls/remove-old-consulting-calls.component';
import { LocalAuthService } from 'src/app/auth/local-auth.service';

@Component({
  selector: 'app-remove-old-calls-main',
  templateUrl: './remove-old-calls-main.component.html',
  styleUrl: './remove-old-calls-main.component.scss',
  standalone: true,
  imports: [RemoveOldCallsMcComponent, RemoveOldCallsRootsComponent, CommonModule, ButtonModule, RemoveOldConsultingCallsComponent]
})
export class RemoveOldCallsMainComponent {
  selectedType: 'mc' | 'roots' | 'consulting' | null = null;

  constructor(private auth: LocalAuthService) { }

  isLeah(): boolean {
    return this.auth.currentUser?.newstaffId === 83;
  }

  isAlissa(): boolean {
    return this.auth.currentUser?.newstaffId === 418;
  }

  allowedRoles(): boolean {
    return this.auth.hasAnyRole(['it']);
  }

}